import { render, staticRenderFns } from "./ManageRewardModal.vue?vue&type=template&id=76d4d49b&"
import script from "./ManageRewardModal.vue?vue&type=script&lang=js&"
export * from "./ManageRewardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports